import React from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import HeroSection from "../../components/HeroSection/HeroSection";
import HeroCaption from "../../components/HeroCaption/HeroCaption";
import galleryImages from "../../static-data/gallery.data";

const GalleryPage = () => {
  return (
    <PageWrapper className="mt-n6">
      <HeroSection className="bg-page-background-11">
        <HeroCaption
          title="Gallery"
          position="bottom-left"
          breadcrumb={true}
          breadcrumbPrefix="Home"
        />
      </HeroSection>

      <div className="container py-5">
        <div className="row">
          {galleryImages.map((image) => (
            <div className="col-md-4 col-sm-6 mb-4" key={image.id}>
              <img
                src={image.src}
                alt={image.alt}
                className="img-fluid gallery-img"
              />
            </div>
          ))}
        </div>
      </div>
    </PageWrapper>
  );
};

export default GalleryPage;
